// API Configuration for Development and Production

const isDevelopment = process.env.NODE_ENV === 'development';

const API_BASE_URLS = {
  development: 'http://localhost:5012', // Change to your dev API URL
  production: 'https://drabhinav.shreejeesoft.in', // Change to your production API URL
};

export const API_BASE_URL = isDevelopment 
  ? API_BASE_URLS.development 
  : API_BASE_URLS.production;

export const API_ENDPOINTS = {
  login: '/Auth/API/apiuserlogin',
  // Blog endpoints
  createBlog: '/api/blogs',
  getBlogs: '/api/blogs',
  getPublishedBlogs: '/api/blogs/published',
  getBlogBySlug: '/api/blogs/slug',
};

export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

export default API_BASE_URL;
